import React from "react";
import PropTypes from "baobab-react/prop-types";
import { branch } from "baobab-react/higher-order";
import _ from "lodash";
import autoBind from "react-autobind";

import * as playerActions from "../../actions/playerActions";
import * as Utils from "../../utils/utils";
import PlayerPaths from "../../constants/paths/playerPaths";

import Section from "./Section";

import ReactCSSTransitionGroup from "react-addons-css-transition-group";

class ListsView extends React.PureComponent {
	constructor(props) {
		super(props);
		autoBind(this);
		this.state = {};
	}

	componentDidMount() {
		window.addEventListener("resize", _.debounce(this.onResize, 50));
		if (!_.isEmpty(this.container) && this.props.appCapabilitiesPlayer.procedure.autoSelectOnScroll) {
			this.setState({
				paddingHeight: this.container.offsetHeight / 2
			});
		}
	}

	componentWillUnmount() {
		window.removeEventListener("resize", _.debounce(this.onResize, 50));
	}

	handleListExpandAll(listIndex) {
		this.props.dispatch(
			playerActions.listExpandAll,
			listIndex
		);
	}

	handleListCollapseAll(listIndex) {
		this.props.dispatch(
			playerActions.listCollapseAll,
			listIndex
		);
	}

	onResize() {
		//// console.log("resize window!");
		if (!_.isEmpty(this.container) && this.props.appCapabilitiesPlayer.procedure.autoSelectOnScroll) {
			this.setState({
				paddingHeight: this.container.offsetHeight / 2
			});
		}
	}

	render() {
		let self = this;
		let sectionCount = 0;
		const { selectedListIndex } = this.props;

		let list = this.props.activity.children[selectedListIndex];

		sectionCount = list.children ? list.children.length : 0;	

		let defaultExpanded = sectionCount === 1 ? true : false;
		let sections;

		let birdseyeSections = [];

		try {
			if (self.props.activity && self.props.activity.children) {
				
				sections = list.children.map((section, j) => {
					let sectionComponent;
					if ((Utils.isVisible(section))) {
						sectionComponent = 
							<Section 
								key={`section-${selectedListIndex}-${j}`} 
								section={section} 
								listIndex={selectedListIndex} 
								sectionIndex={j} 
								activity={this.props.activity} 
								listStyles={list.styles} 
								sectionStyles={section.styles} 
								defaultNodeExpanded={defaultExpanded} 
								sectionsCount={sectionCount}/>;
						birdseyeSections.push(
							<Section 
								key={`section-${selectedListIndex}-${j}`} 
								section={section} 
								listIndex={selectedListIndex} 
								sectionIndex={j} 
								activity={this.props.activity} 
								listStyles={list.styles} 
								sectionStyles={section.styles} 
								defaultNodeExpanded={defaultExpanded} 
								birdseye={true} 
								sectionsCount={sectionCount}/>
						);
		
					}
					return sectionComponent;
				});
			}
		} catch (e) {
			console.error(e);
			alert(e.message);
			list =
				<div>There was an error getting the content for the activity!</div>;
		}

		// onScroll={this.handleScroll}
		let listView = 
			<div>
				<div className="top-list-view" style={{ maxWidth: this.props.defaultColumnWidth, width: "100%", marginLeft: "auto", marginRight: "auto" }}>			
					<div style={{ height: this.state.paddingHeight ? this.state.paddingHeight - 100 : "auto" }} />
					<div>{sections}</div>
					<div style={{ height: this.state.paddingHeight ? this.state.paddingHeight + 50 : "auto" }} />
				</div>
				<ReactCSSTransitionGroup
				transitionName="fade">
				{this.props.sectionsMenuVisible &&
					<div style={{
						display: "flex",
						flex: 1,
						justifyContent: "center",
						// alignItems: "center",		
						backgroundColor: "rgba(0,0,0,.9)",
						position: "absolute",
						top: 0,
						right: 0,
						bottom: 0,
						left: 0,
						zIndex: 9,
						overflow: "auto"
					}} onClick={() => { playerActions.toggleSectionsMenuVisible(this.context.tree); }}>
						<div style={{flexDirection: "column"}}>
							{/* <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", flex: 0, flexDirection: "row" }}>
								<Button style={{ backgroundColor: "rgba(255,0,0,.1)", marginTop: "5px", marginRight: "10px", alignSelf: "flex-end" }}><FontAwesomeIcon style={{fontSize: "24px", fontWeight: "bold", color: "red"}} icon="times" /></Button>
							</div> */}
							<div style={{  display: "flex", flex: 1, height: "100%", flexDirection: "row", flexWrap: "wrap" }}>
								{birdseyeSections}
							</div>
						</div>	
					</div>
				}          
				</ReactCSSTransitionGroup>					
			</div>;
			

		return listView;
	}
}


ListsView.contextTypes = {
	tree: PropTypes.baobab
};

export default branch((props, context) =>
{
	return {
		activityTheme: ["activity", "theme"],
		user: ["user"],
		selectedListIndex: PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX,
		defaultColumnWidth: Utils.getDefaultColumnWidthBranchPath(context.tree),	
		sectionsMenuVisible: ["appState","sectionsMenuVisible"]
	
	};

}, ListsView);